import { FluentProvider } from '@fluentui/react-components';
import React, { FC, PropsWithChildren, useMemo } from 'react';
import { darkTheme, lightTheme } from '../Theme/fluentuiConfig';

export interface ForceThemeProps {
    theme?: 'light' | 'dark' | undefined;
}

export const ForceTheme: FC<PropsWithChildren<ForceThemeProps>> = (props) => {
    const { children, theme } = props;

    const fluentTheme = useMemo(() => {
        switch (theme) {
            case 'light':
                return lightTheme;
            case 'dark':
                return darkTheme;
        }
        return undefined;
    }, [theme]);

    return <>{fluentTheme ? <FluentProvider theme={fluentTheme}>{children}</FluentProvider> : children}</>;
};
